import React from 'react';
import _ from 'lodash';
import { Form, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  MODAL_CHECK_BOX_LABEL_STYLE,
  MODAL_CHECK_BOX_STYLE,
  DEFAULT_SCORE_COEFFICIENTS,
  getDefaultScoreCoefficient,
} from '../../../HelperMethods/constants';
import { permissionCheck } from './helper';

const EngineParameters = ({
  parameters,
  onEngineParameterChange,
  planningModeModalOpen = false,
  taskViewEngineSettingsManagement = false,
  validation = {},
}) => {
  const {
    timeLimit,
    // highScoreThreshold,
    // highScoreCoefficient,
    // balanceTechTimeCoefficient,
    unassignUsers,
    enableClustering,
    enableGroupClustering,
    disableTechEndLocation,
    useCrowFlyDistances,
    useUserLocation,
    disableAvailabilityRestriction,
    timeBuffer,
    balanceTechShiftUtilization,
    crowFlyDistanceFactorPercentage,
    startDateLte,
    autoFreezTimeLte,
    startTimeLte,
    maxStartDateLte,
  } = parameters;
  const scoreCoefficient = getDefaultScoreCoefficient(parameters.scoreCoefficient);
  const loggedInUser = useSelector((state) => state.appReducer.loggedInUser);

  return (
    <Grid>
      {!planningModeModalOpen && (
        <>
          <Grid.Row style={{ paddingBottom: 0 }}>
            <Grid.Column columns={1}>
              <Form.Field inline>
                <label>
                  Consider tasks that start before {`${taskViewEngineSettingsManagement ? '' : 'next day'}`}
                </label>
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2}>
            {taskViewEngineSettingsManagement && (
              <Grid.Column>
                <Form.Field inline>
                  <label>Date</label>
                  <input
                    className="date-input-with-sematic"
                    style={{ width: '100%' }}
                    type="date"
                    max={maxStartDateLte}
                    value={startDateLte}
                    name="startDateLte"
                    onChange={(event) => {
                      onEngineParameterChange(event.target.name, event.target.value);
                    }}
                  />
                  {_.get(validation, 'startDateLte') && (
                    <div className="errorText">*{_.get(validation, 'startDateLte')}</div>
                  )}
                </Form.Field>
              </Grid.Column>
            )}
            <Grid.Column>
              <Form.Field inline>
                <label>Time</label>
                <input
                  className="date-input-with-sematic"
                  style={{ width: '100%' }}
                  type="time"
                  // min={this.props.planningStartTime}
                  value={startTimeLte}
                  name="startTimeLte"
                  onChange={(event) => {
                    onEngineParameterChange(event.target.name, event.target.value);
                  }}
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Form.Field inline>
                <label>Auto freeze assigned and sequenced tasks until</label>
                <input
                  className="date-input-with-sematic"
                  style={{ width: '100%' }}
                  type="time"
                  // min={this.props.planningStartTime}
                  value={autoFreezTimeLte}
                  name="autoFreezTimeLte"
                  onChange={(event) => {
                    onEngineParameterChange(event.target.name, event.target.value);
                  }}
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
        </>
      )}

      <Grid.Row columns={2}>
        {permissionCheck('timeLimit', loggedInUser) && (
          <Grid.Column>
            <Form.Field inline>
              <label>Time Limit (ms)</label>
              <input
                type="number"
                value={timeLimit}
                name="timeLimit"
                onChange={(event) => {
                  onEngineParameterChange(event.target.name, event.target.value);
                }}
              />
            </Form.Field>
          </Grid.Column>
        )}
        {permissionCheck('scoreCoefficient', loggedInUser) && (
          <Grid.Column>
            <Form.Field inline>
              <label>Score Cost Co-efficient</label>
            </Form.Field>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>Distance</div>
              {DEFAULT_SCORE_COEFFICIENTS.map((item, index) => {
                const { value } = item;
                const isSelected = scoreCoefficient === value;
                return (
                  <div
                    title={value}
                    className={isSelected ? 'score-coef-circle score-coef-circle-selected' : 'score-coef-circle'}
                    key={index}
                    name="scoreCoefficient"
                    onClick={() => {
                      onEngineParameterChange('scoreCoefficient', value);
                    }}
                  />
                );
              })}
              <div>Priority</div>
            </div>
          </Grid.Column>
        )}
      </Grid.Row>
      {/* <Grid.Row columns={2}>
        <Grid.Column>
          <Form.Field inline>
            <label>High Score Threshold</label>
            <input
              type="number"
              value={highScoreThreshold}
              name="highScoreThreshold"
              onChange={(event) => {
                onEngineParameterChange(event.target.name, event.target.value);
              }}
            />
          </Form.Field>
        </Grid.Column>
        <Grid.Column>
          <Form.Field inline>
            <label>High Score Cost Co-efficient</label>
            <input
              type="number"
              value={highScoreCoefficient}
              name="highScoreCoefficient"
              onChange={(event) => {
                onEngineParameterChange(event.target.name, event.target.value);
              }}
            />
          </Form.Field>
        </Grid.Column>
      </Grid.Row> */}
      <Grid.Row columns={2}>
        {/* <Grid.Column>
          <Form.Field inline>
            <label>Balance Tech Time Co-efficient</label>
            <input
              type="number"
              min="0"
              max="5"
              step="1"
              value={balanceTechTimeCoefficient}
              name="balanceTechTimeCoefficient"
              onChange={(event) => {
                onEngineParameterChange(event.target.name, event.target.value);
              }}
            />
          </Form.Field>
        </Grid.Column> */}
        {permissionCheck('timeBuffer', loggedInUser) && (
          <Grid.Column>
            <Form.Field inline>
              <label>
                Same Start Time Buffer <i>(in minutes)</i>
              </label>
              <input
                type="number"
                min="0"
                step="1"
                value={timeBuffer}
                name="timeBuffer"
                onChange={(event) => {
                  onEngineParameterChange(event.target.name, event.target.value);
                }}
              />
            </Form.Field>
          </Grid.Column>
        )}
      </Grid.Row>
      <Grid.Row columns={2}>
        {permissionCheck('unassignUsers', loggedInUser) && (
          <Grid.Column>
            <Form.Field
              inline
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                onEngineParameterChange('unassignUsers', !unassignUsers);
              }}
            >
              {unassignUsers ? (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
              ) : (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
              )}
              <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Keep existing Assignments for on-shift Users</label>
            </Form.Field>
          </Grid.Column>
        )}
        {permissionCheck('disableTechEndLocation', loggedInUser) && (
          <Grid.Column>
            <Form.Field
              inline
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                onEngineParameterChange('disableTechEndLocation', !disableTechEndLocation);
              }}
            >
              {disableTechEndLocation ? (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
              ) : (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
              )}
              <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Disable Tech End Location</label>
            </Form.Field>
          </Grid.Column>
        )}
      </Grid.Row>

      <Grid.Row columns={2}>
        {permissionCheck('enableClustering', loggedInUser) && (
          <Grid.Column>
            <Form.Field
              inline
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                onEngineParameterChange('enableClustering', !enableClustering);
              }}
            >
              {enableClustering ? (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
              ) : (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
              )}
              <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Enable Clustering</label>
            </Form.Field>
          </Grid.Column>
        )}
        {permissionCheck('enableGroupClustering', loggedInUser) && (
          <Grid.Column>
            <Form.Field
              inline
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                onEngineParameterChange('enableGroupClustering', !enableGroupClustering);
              }}
            >
              {enableGroupClustering ? (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
              ) : (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
              )}
              <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Enable Group Clustering</label>
            </Form.Field>
          </Grid.Column>
        )}
      </Grid.Row>
      <Grid.Row columns={2}>
        {permissionCheck('useCrowFlyDistances', loggedInUser) && (
          <Grid.Column>
            <Form.Field
              inline
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                onEngineParameterChange('useCrowFlyDistances', !useCrowFlyDistances);
              }}
            >
              {useCrowFlyDistances ? (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
              ) : (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
              )}
              <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Use Crow Fly Distances</label>
            </Form.Field>
            {useCrowFlyDistances && (
              <Form.Field inline>
                <label>Additional Distance Factor (%)</label>
                <input
                  type="number"
                  min="0"
                  value={crowFlyDistanceFactorPercentage}
                  name="crowFlyDistanceFactorPercentage"
                  onChange={(event) => {
                    onEngineParameterChange(event.target.name, event.target.value);
                  }}
                />
              </Form.Field>
            )}
          </Grid.Column>
        )}
        {permissionCheck('useUserLocation', loggedInUser) && (
          <Grid.Column>
            <Form.Field
              inline
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                onEngineParameterChange('useUserLocation', !useUserLocation);
              }}
            >
              {useUserLocation ? (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
              ) : (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
              )}
              <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Use User Location</label>
            </Form.Field>
          </Grid.Column>
        )}
      </Grid.Row>
      <Grid.Row columns={2}>
        {permissionCheck('balanceTechShiftUtilization', loggedInUser) && (
          <Grid.Column>
            <Form.Field
              inline
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                onEngineParameterChange('balanceTechShiftUtilization', !balanceTechShiftUtilization);
              }}
            >
              {balanceTechShiftUtilization ? (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
              ) : (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
              )}
              <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Balance Techs Shift Utilization </label>
            </Form.Field>
          </Grid.Column>
        )}
        {permissionCheck('disableAvailabilityRestriction', loggedInUser) && (
          <Grid.Column>
            <Form.Field
              inline
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                onEngineParameterChange('disableAvailabilityRestriction', !disableAvailabilityRestriction);
              }}
            >
              {disableAvailabilityRestriction ? (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-check-square ag-grid-checkbox" />
              ) : (
                <i style={MODAL_CHECK_BOX_STYLE} className="fa fa-square ag-grid-checkbox" />
              )}
              <label style={MODAL_CHECK_BOX_LABEL_STYLE}>Disable Location Restriction Timings</label>
            </Form.Field>
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid>
  );
};

EngineParameters.propTypes = {
  parameters: PropTypes.object.isRequired,
  onEngineParameterChange: PropTypes.func.isRequired,
  taskViewEngineSettingsManagement: PropTypes.bool,
  planningModeModalOpen: PropTypes.bool,
  validation: PropTypes.object,
};

export default EngineParameters;
